import React from 'react';
import { useAuth } from './AuthContext';

/**
 * Full-screen login page shown when the user is not authenticated.
 * Clicking "Sign in with Microsoft" redirects to Azure AD.
 */
export default function LoginPage() {
  const { login, error } = useAuth();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>OP</div>
        <h1 style={styles.title}>Orders Portal</h1>
        <p style={styles.subtitle}>Sign in with your organisation account to continue</p>

        {error && (
          <div style={styles.error}>
            {error}
          </div>
        )}

        <button style={styles.button} onClick={() => login(window.location.pathname + window.location.search)}>
          <svg style={styles.msIcon} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    background: '#fff',
    borderRadius: 12,
    padding: '48px 40px',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    maxWidth: 400,
    width: '100%',
  },
  logo: {
    width: 56,
    height: 56,
    borderRadius: 12,
    background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
    color: '#fff',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 16,
  },
  title: {
    margin: '0 0 8px',
    fontSize: 24,
    fontWeight: 700,
    color: '#0f172a',
  },
  subtitle: {
    margin: '0 0 32px',
    fontSize: 14,
    color: '#64748b',
  },
  error: {
    background: '#fef2f2',
    color: '#dc2626',
    border: '1px solid #fecaca',
    borderRadius: 8,
    padding: '10px 14px',
    fontSize: 13,
    marginBottom: 20,
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 28px',
    fontSize: 15,
    fontWeight: 600,
    color: '#1e293b',
    background: '#f8fafc',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'all 0.15s',
  },
  msIcon: {
    width: 20,
    height: 20,
  },
};
